//----------------------------------------

import { Dispatch, SetStateAction, createContext, useEffect, useMemo, useState } from "react"
import { UmbracoNode } from "../../models/UmbracoNode"
import { fetchAPI } from "../../Helpers/utils"

// REDUCER
export enum FAQActionEnum {
  SET_RESULTS,
  SEARCH
}

export type FAQState = {
  faqs: UmbracoNode[]
}

export type FAQAction = |
{ action: FAQActionEnum.SET_RESULTS, payload: UmbracoNode[] }

//----------------------------------------
// CONTEXT
export type FAQContextType = {
  faqs: UmbracoNode[] | null,
  searchTerm: string,
  totalRecords: number,

  termSetter: Dispatch<SetStateAction<string>>
}

export const FAQContext = createContext<FAQContextType | null>(null);

//----------------------------------------
// PROVIDER
export type FAQProviderModel = {
  source: number,
  children: React.ReactNode
}

export default function FAQProvider({ source, children }: FAQProviderModel) {
 const [faqs, setFAQs] = useState<UmbracoNode[] | null>([]);
 const [searchTerm, setSearchTerm] = useState<string>('');
 const [totalRecords, setTotalRecords] = useState<number>(0);

 useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get('q');
    if (query) {
      setSearchTerm(query);
    }
  }, []);

  useEffect(() => {
    async function search() {
      const data = await fetchAPI('/api/faq', {
        source: source,
        searchTerm: searchTerm
      }) as any;

      setFAQs(data);
      setTotalRecords(data.length);
    }

    search();
  }, [source, searchTerm]);

  const values = useMemo(() => {
    return {
      faqs,
      searchTerm,
      totalRecords,

      termSetter: setSearchTerm
    }
  }, [
    faqs,
    searchTerm,
    totalRecords
  ]);

  return (
    <FAQContext.Provider value={values}>
      {children}
    </FAQContext.Provider>
  )
}